import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Lock, Mail, Loader2, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
    const navigate = useNavigate();
    const { login, user } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (user && user !== false && user !== null) {
            navigate("/admin", { replace: true });
        }
    }, [user, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        const res = await login(email.trim().toLowerCase(), password);
        setSubmitting(false);
        if (res.ok) {
            toast.success("Willkommen", { description: "Sie sind angemeldet." });
            navigate("/admin", { replace: true });
        } else {
            toast.error("Anmeldung fehlgeschlagen", { description: res.error });
        }
    };

    return (
        <div className="min-h-screen bg-cream flex flex-col" data-testid="admin-login-page">
            <div className="container-page py-6">
                <Link to="/" className="inline-flex items-center gap-2 text-sm text-stone-600 hover:text-ink" data-testid="back-to-site">
                    <ArrowLeft size={16} />
                    Zurück zur Website
                </Link>
            </div>

            <div className="flex-1 flex items-center justify-center px-6">
                <div className="w-full max-w-md bg-white border border-stone-200 p-10">
                    <div className="text-center mb-8">
                        <div className="font-heading text-3xl text-ink">G21 Admin</div>
                        <p className="overline mt-2">Anfragen-Verwaltung</p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-6" data-testid="admin-login-form">
                        <div>
                            <label className="label-line">E-Mail</label>
                            <div className="relative">
                                <Mail size={16} className="absolute left-0 top-3.5 text-stone-400" />
                                <input
                                    type="email"
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="input-line pl-7"
                                    placeholder="buero@neubau-kaufen-wiesbaden.de"
                                    autoComplete="email"
                                    data-testid="admin-email"
                                />
                            </div>
                        </div>

                        <div>
                            <label className="label-line">Passwort</label>
                            <div className="relative">
                                <Lock size={16} className="absolute left-0 top-3.5 text-stone-400" />
                                <input
                                    type="password"
                                    required
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="input-line pl-7"
                                    placeholder="••••••••"
                                    autoComplete="current-password"
                                    data-testid="admin-password"
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            disabled={submitting}
                            className="btn-primary w-full disabled:opacity-60"
                            data-testid="admin-login-submit"
                        >
                            {submitting ? (
                                <>
                                    <Loader2 size={16} className="animate-spin" />
                                    Anmelden…
                                </>
                            ) : (
                                "Anmelden"
                            )}
                        </button>
                    </form>

                    <p className="mt-8 text-center font-body text-xs text-stone-500">
                        Vergessen Sie nicht, das Standard-Passwort nach dem ersten Login zu ändern.
                    </p>
                </div>
            </div>
        </div>
    );
}
